/* Main application definitions - to be generated by App Gen 
 * from user requests
 */
import React from 'react';

export const YahaVersion = "build.144Y" // since build 125, MBO 33!!

//======== Domain setup: single/network with branches...

//export const HostUrl = "https://tms.digma.me" // Network configuration
// Actual value of HostUrl is set in Login form!! MainDomain
//export var  HostUrl = 'https://tms.digma.me'

//export const HostUrl = 'https://d.w2go.co.il'  // 'https://tms.digma.me' // 
export const HostUrl = 'https://yyy.today' // 'https://digma.me'  // 'https://tms.digma.me' // 
//export const HostUrl = 'https://digma.tech'  // 'https://tms.digma.me' // 
export const DigmaNetwork = false
// Only if network...
export const Branches = [HostUrl, 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7'] // Netword branches - main is always first!
export const BranchNames = ['ראשי', 'דרום', 'מרכז', 'צפון', '**מזרח', '**מערב', '**רחוק', '**קרוב'] // Netword branches - main is always first!


//======== Project name & Slogan for projects are below...
const ProductionYahav = ( HostUrl === 'https://digma.me' || HostUrl === 'https://yyy.today' )
export const Slogan = ProductionYahav ? <h3>יחד  &bull;  המשפחה  &bull;  בצמיחה</h3>
                        : <h3>ניהול  &bull;  מוטבים  &bull;  להצלחה</h3> // תיעוד מדידות תוצאות

export const ProjectName =      !ProductionYahav ? 'דיגמה.טק' : 'יהב'
export const ProjectSlogan =    !ProductionYahav ? 'ניהול מוטבים להצלחה' : 'יחד המשפחה בצמיחה'
export const ProjectSlogan2 =   !ProductionYahav ? 'ניהול מוטבים' : 'ניהול משפחות'

// ======== Menu Definitions
//const DigmaGeneric = HostUrl !== 'https://digma.me' || HostUrl !== 'https://yyy.today'
export const DigmaMenuDashboard = "לוח בקרה"
export const DigmaMenuReferrals = "ניהול הפניות"
export const DigmaMenuIntakes = !ProductionYahav ? "מוטבים באינטייק": "משפחות באינטייק"
export const DigmaMenuProgram = !ProductionYahav ? "מוטבים בתוכנית": "משפחות בתוכנית"
export const DigmaMenuAll =     !ProductionYahav ? "כל המוטבים": "כל המשפחות"
export const DigmaMenuForms = "ניהול טפסים"
export const DigmaMenuQuery = "מחולל שאילתות"

// Entities
export const DigmaEntity = !ProductionYahav ? "מוטבים": "משפחות"